import CreateMenuController from "../../affiliate_campaign/create_menu/component";
import "./component.scss";

// Reuse the campaign disclosure's outside-click and Escape/focus handling.
export default class extends CreateMenuController {
  open(event) {
    super.open(event);
    if (event?.detail === 0) this.popoverTarget.querySelector("button")?.focus();
  }
}
